import qs from 'qs';
import { network } from 'services/network';

import { QueryFnResponse } from 'api/queries/getTaskDataByHashCode.query';

export const getTaskDataByHashCode = (params) => {
    const querystring = qs.stringify({ ...params }, { addQueryPrefix: true, skipNulls: true, arrayFormat: 'comma' });
    const url = `api/bo/getTaskDataByHashCode${querystring}`;
    return network.get<QueryFnResponse[]>(url).then((response) => response.data);
};
